import { intlFormat } from 'date-fns/intlFormat';

export const formatPeriodDays = (period: {
  from: Date | string;
  to: Date | string;
}) => {
  return {
    from: intlFormat(
      period.from,
      {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      },
      {
        locale: 'fr',
      },
    ),
    to: intlFormat(
      period.to,
      {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      },
      {
        locale: 'fr',
      },
    ),
  };
};
